export enum TemplateBodyTypeDTO {
    Html = "Html",
    Text = "Text"
}
